import React from 'react'

const WeddingBands = () => {
  return (
    <iframe scrolling="yes" width="100%" height="3000px" frameborder="0" sandbox="allow-scripts allow-forms allow-same-origin" src="https://morgantaylor-frame-categoryembed.jewelershowcase.com/browse/wedding-and-engagement/wedding-bands/"></iframe>
  )
}

export default WeddingBands
